export const COLORS = {
  primary: "#003554",
  secondary: "#FFF",
  fadePrimary: "#D9E8E6",
  background: "#EFEFEF"
};

const globalStyles = {
  primaryButtonContainer: {
    backgroundColor: COLORS.primary,
    borderColor: "transparent",
    borderWidth: 4,
    padding: 16,
    margin: 16,
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center"
  },
  primaryButtonText: {
    color: COLORS.secondary,
    fontSize: 16,
    textAlign: "center",
    marginLeft: 8
  },
  secondaryButtonContainer: {
    backgroundColor: COLORS.secondary,
    borderColor: COLORS.primary,
    borderWidth: 2,
    padding: 16,
    margin: 16,
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center"
  },
  secondaryButtonText: {
    color: COLORS.primary,
    fontSize: 16,
    textAlign: "center",
    marginLeft: 8
  },
  dangerButtonContainer: {
    backgroundColor: "red",
    borderColor: "transparent",
    borderWidth: 4,
    padding: 16,
    margin: 16,
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center"
  },
  dangerButtonText: {
    color: COLORS.secondary,
    fontSize: 16,
    textAlign: "center",
    marginLeft: 8
  },
  dangerButtonContainerModal: {
    width: "100%",
    backgroundColor: "red",
    borderColor: "transparent",
    borderWidth: 2,
    padding: 16,
    margin: 16,
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center"
  },
  buttonContent: {
    flexDirection: "row",
    alignItems: "center"
  },
  primaryButtonContainerModal: {
    width: "100%",
    backgroundColor: COLORS.primary,
    borderColor: "transparent",
    borderWidth: 2,
    padding: 16,
    margin: 16,
    borderRadius: 30,
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "center"
  },
  title: {
    fontSize: 28,
    fontWeight: "600",
    textAlign: "left"
  },
  titleFlex: {
    flex: 1,
    fontSize: 28,
    fontWeight: "600",
    textAlign: "left"
  },
  subtitle: {
    flex: 1,
    fontSize: 18,
    textAlign: "center"
  },
  inputContainerModal: {
    width: "100%",
    backgroundColor: "#FFF",
    borderWidth: 0,
    borderColor: "#ccc",
    borderRadius: 8,
    padding: 10,
    marginBottom: 16
  },
  inputContainer: {
    backgroundColor: "#FFF",
    borderWidth: 0,
    borderColor: "#ccc",
    borderRadius: 8,
    padding: 10,
    marginBottom: 16
  },
  inputLabel: {
    alignSelf: "baseline",
    fontSize: 16,
    fontWeight: "600",
    marginVertical: 8
  }
};
export default globalStyles;
